<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Informe De Inspección
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-window v-model="step" show-arrows show-arrows-on-hover>   
                            <v-window-item :value="1">
                                <windowSegurosClienteComponent :listSeguros="_.get(listGeneral,'listSeguro',[])"
                                                               :idSeguro="_.toNumber(objSearch.idSeguro)"
                                />
                            </v-window-item>

                            <v-window-item :value="2" v-if="_.toNumber(_.get(objSearch,'idSeguro'),0) == _.toNumber(parametro.id_seguro_vehiculo)">
                                <windowInformeInspeccionVehiculoComponent :listCertificado="_.get(listGeneral,'listCertificado',[])"/>
                            </v-window-item>
                        </v-window>
                    </v-col>
                </v-row>
               
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        components: {
            windowSegurosClienteComponent: () => import('@/components/consulta/informe/windowSegurosClienteComponent.vue'),
            windowInformeInspeccionVehiculoComponent: () => import('@/components/consulta/informe/windowInformeInspeccionVehiculoComponent.vue')
        },
        data:() => ({
            step:1,
            objSearch: {
                opcion: 'LISTAR',
                idSeguro:null,
                idPoliza:null,
                idCertificado:null,
                idEstado:null
            },
            listGeneral:{},
            parametro:{},
            idCliente:null
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-inspeccion/cargaGeneral`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0){ throw error = 'I'; _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)} ;
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametro',r.data.data.parametro);
                        this.idCliente =  _.get(this.$root.obUsuario,'idCliente',null);
                        return this.onListarSeguro('L');
                 })
                 .catch((e) => {
                    mensajesAlerta(e, error);
                    return e;
                });
                 
        },
        watch:{
            step(val){
                if(val == 2)
                    this.onListarCertificadoVehiculo('L');
            }
        },
        methods:{
            onListarSeguro(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var objeto ={
                        opcion:'LISTAR_CERTIFICADOS',
                        idCliente:this.idCliente
                    };

                    this.listGeneral.listSeguro = {};
                    
                    axios.post(`${BASE_URI}administrador/informe-inspeccion/listar`,objeto)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0){ throw error = 'I'; _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)} ;
                                var l = _.cloneDeep(r.data.data);

                                l = _.map(l,(v)=>{
                                    v.foto = require(`@/assets/img/seguro/${v.idSeguro}.png`);
                                    return v;
                                });

                                this.listGeneral.listSeguro = _.uniqBy(l,'idSeguro');
                         })
                         .catch((e) => {
                            mensajesAlerta(e, error);
                            return e;
                        });
                }
            },
            onListarCertificadoVehiculo(event){
                if(!_.isUndefined(event)){
                    var error = 'E';

                    this.listGeneral.listCertificado =[];
                    var o = {opcion:'LISTAR_CERTIFICADO_VEHICULO',idCliente:this.idCliente, idSeguro: this.objSearch.idSeguro};
                    axios.post(`${BASE_URI}administrador/informe-inspeccion/listar`,o)
                          .then((r) =>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    this.listGeneral.listCertificado = r.data.data; 
                            })
                            .catch((e) => {
                                mensajesAlerta(e, error);
                                return e;
                            })
                }
            },
            setData(keyNameObject,data)  {
                var z = _.get(this,keyNameObject,{});
                if(_.isArray(z))
                    _.set(this,keyNameObject,data);
                else
                    _.set(this,keyNameObject,_.merge({},z,data));
            },
            setStep(n){
                this.step = n;
            }
        },
        provide(){
            return{
                setData:this.setData,
                setStep:this.setStep
            }
        }
    }
</script>